import React ,{ useState,useEffect }from "react";
import { makeStyles } from "@material-ui/core/styles";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { fetchConToken } from "../../../helpers/fetch";

const useStyles = makeStyles((theme) => ({
    root: {
      width:500,
      marginBottom:25,
      borderBottom: '1px solid white',
      
    },
    icon: {
       fill: '#FAFAFA',
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: "#FAFAFA",
    },

    cssLabel: {
      color:'#FAFAFA',//required color
      
    },
  }));



export const SelectTipoAfiliacion = (props) => {
  const classes = useStyles();
  const [listaTipos, setListaTipos] = useState([]);
 
  useEffect(() => {
    const traerDatos = async () => {
      const response = await fetchConToken(props.apiUrl);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (lista) {
          let tiposFromApi = lista.map((tipo) => {
            return {
              value: tipo.id_tipo_afiliacion,
              display: tipo.descripcion_afiliacion,
            };
          });
          setListaTipos(tiposFromApi);
        }
      }
    };
    traerDatos();
  }, [props.apiUrl]);


  return (
    <>
      <FormControl
        classes={{root:classes.root}}
        margin="normal"
        fullWidth={true}
      >
        <InputLabel className={classes.cssLabel}>Tipo Relacion</InputLabel>
        <Select    
          name="id_tipo_afiliacion"
          onChange={props.handleChange}
          label="Tipo Afiliacion"
          inputProps={{
            classes: {
                root: classes.border,
                icon: classes.icon,
            },
        }}
        >
          {listaTipos.map((t) => (
            <MenuItem key={t.value} value={t.value}>
              {t.display}
            </MenuItem>
          ))}
          
        </Select>
      </FormControl>
    </>
  );

};
